import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { db } from "./firebase-config";
import { getDocs, collection } from "@firebase/firestore";
import NavigationTabs from './NavigationTabs';
import ServicePage from './ServicePage';
import ResourcePage from './ResourcePage';
import PlaylistsPage from './PlaylistsPage';
import './App.css';

function App() {
  const [resources, setResources] = useState([]);
  const [services, setServices] = useState([]);
  const [playlists, setPlaylists] = useState([]);

  useEffect(() => {
    const loadResources = async () => {
      const querySnapshot = await getDocs(collection(db, "well-being-resources"));
      const loadedResources = querySnapshot.docs.map(doc => doc.data())
        .sort((a, b) => a.name.localeCompare(b.name)); // Sorting resources alphabetically
      setResources(loadedResources);
    };

    const loadServices = async () => {
      const querySnapshot = await getDocs(collection(db, "well-being-services"));
      const loadedServices = querySnapshot.docs.map(doc => ({
        ...doc.data(),
        coords: {
          latitude: doc.data().coords.latitude + (Math.random() - 0.5) * 0.01,
          longitude: doc.data().coords.longitude + (Math.random() - 0.5) * 0.01
        }
      })).sort((a, b) => { // Sorting services alphabetically
        const nameA = a.is_individual && a.individual_name.trim() !== "" ? a.individual_name : a.business_name;
        const nameB = b.is_individual && b.individual_name.trim() !== "" ? b.individual_name : b.business_name;
        return nameA.localeCompare(nameB);
      });
      setServices(loadedServices);
    };

    const loadPlaylists = async () => {
      const querySnapshot = await getDocs(collection(db, "well-being-playlists"));
      const loadedPlaylists = querySnapshot.docs.map(doc => doc.data())
        .sort((a, b) => a.name.localeCompare(b.name));
      setPlaylists(loadedPlaylists);
    };

    loadResources();
    loadServices();
    loadPlaylists();
  }, []);

  return (
    <Router>
      <div className="App">
        <NavigationTabs />
        <Routes>
          <Route path="/well-being/services" element={<ServicePage key="services" services={services} />} />
          <Route path="/well-being/resources" element={<ResourcePage key="resources" resources={resources} />} />
          <Route path="/well-being/playlists" element={<PlaylistsPage key="playlists" resources={playlists} />} />
          <Route path="*" element={<Navigate to="/well-being/services" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
